module.exports = __webpack_public_path__ + "static/img/bianchiOmbra.e125c0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/products/bianchiOmbra.jpg
// module id = RBlz
// module chunks = 1